<eda-dialog2 [display]="displayWindow" [header]="title" width="55vw" height="70vh" [overflow]="'auto'"
  (apply)="onApply()" (close)="closeDialog()">
  <div content>
    <div class="flex flex-col gap-3 mt-4">

      <div class="section-card">
          <h4 class="section-title" i18n="@@filtrarH4">Filtrar</h4>
        <div class="grid grid-cols-[42.5%_42.5%_15%] gap-3 items-start">

          <!-- Tipo y ámbito de filtro + switch -->
          <div class="flex flex-col gap-3 w-full">
            <p-dropdown id="types" [options]="filter.types" [(ngModel)]="filterSelected" optionLabel="label"
              [autoDisplayFirst]="false" [style]="{'width': '100%'}" [showClear]="true"
              i18n-placeholder="@@tiposFiltrosLabel" placeholder="Tipos de filtro"
              (onChange)="handleFilterChange(filterSelected)">
            </p-dropdown>

            @if (filterSelected && selectedColumn?.column_type === 'numeric' && !display.switchButton) {
              <p-dropdown
                id="whereHaving"
                [options]="filterBeforeAfter.elements"
                [(ngModel)]="filterBeforeAfterSelected"
                optionLabel="label"
                [autoDisplayFirst]="true"
                [style]="{'width': '100%'}"
                i18n-placeholder="@@whereHavingLabel" placeholder="Ámbito del filtro"
                (onChange)="whereHavingSwitch(filterBeforeAfterSelected)">
              </p-dropdown>
            }

            <div class="flex items-center gap-2">
              <label class="text-base text-gray-600" i18n="@@optionsLabel" for="filter_options">Opciones</label>
              <p-inputSwitch id="filter_options" [(ngModel)]="filter.switch" [disabled]="display.switchButton"
                (onChange)="loadDropDrownData()">
              </p-inputSwitch>
            </div>
          </div>

          <!-- Valores de los filtros -->
          <div class="flex flex-col w-full gap-3">
            @if (!!display.calendar && !filter.switch) {
              <eda-date-picker
                #myCalendar
                class="h-[3.2rem]"
                (onDatesChanges)="processPickerEvent($event)"
                [filterSelected]="filterSelected"
                [selectionMode]="display.between ? 'range' : 'single'">
              </eda-date-picker>
            }
            @if (display.filterValue && !display.calendar && !filter.switch) {
              <input
                id="float-input1"
                class="w-full h-[3.2rem] rounded-md border border-gray-300 px-3 py-2"
                [type]="inputType"
                [(ngModel)]="filterValue.value1"
                (input)="handleValidForm({ value1: filterValue.value1 })"
                i18n-placeholder="@@valor1Label" placeholder="Valor 1"
                pInputText
              />
            }
            @if (filter.switch) {
              <div class="w-full h-[3.2rem] [&_.p-multiselect]:h-full [&_.p-multiselect-label-container]:h-full [&_.p-multiselect-label-container]:flex [&_.p-multiselect-label-container]:items-center">
                <p-multiSelect
                  [options]="dropDownFields"
                  [(ngModel)]="filterValue.value1"
                  [virtualScroll]="true"
                  [itemSize]="34"
                  [filter]="true"
                  [style]="{width:'100%', height:'100%'}"
                  [panelStyle]="{minWidth:'100%'}"
                  (onChange)="handleValidForm({value1: filterValue.value1})"
                  defaultLabel="Selecciona..."
                  [loading]="loading"
                  [selectionLimit]="limitSelectionFields"
                  id="float-input1">
                </p-multiSelect>
              </div>
            }
            @if (!!display.between) {
              @if (!display.calendar && !filter.switch) {
                <input id="float-input2" class="h-[3.2rem] w-full rounded-md border border-gray-300 px-3 py-2" [type]="inputType"
                  [(ngModel)]="filterValue.value2" (input)="handleValidForm({value2: filterValue.value2})"
                  i18n-placeholder="@@valor2Label" placeholder="Valor 2" pInputText>
              }
              @if (filter.switch) {
                <div class="w-full h-[3.2rem] [&_.p-multiselect]:h-full [&_.p-multiselect-label-container]:h-full [&_.p-multiselect-label-container]:flex [&_.p-multiselect-label-container]:items-center">
                  <p-multiSelect [options]="dropDownFields" [(ngModel)]="filterValue.value2" [virtualScroll]="true" [itemSize]="34"
                    [filter]="true" [style]="{width:'100%', height:'100%'}" [panelStyle]="{minWidth:'100%'}"
                    (onChange)="handleValidForm({value2: filterValue.value2})" i18n-defaultLabel="@@groupSelect" defaultLabel="Selecciona..."
                    [selectionLimit]="limitSelectionFields" id="float-input2">
                  </p-multiSelect>
                </div>
              }
            }
          </div>

          <!-- Botón añadir filtro -->
          <div>
            <button class="addFilter-button" (click)="addFilter()" [disabled]="display.filterButton">
              <i class="fa fa-plus mr-1"></i>
              <span i18n="@@addFilterBtn">Añadir filtro</span>
            </button>
          </div>

        </div>
      </div>

      <!-- Lista de filtros activos -->
      @if (filter.forDisplay.length > 0) {
        <div class="section-card pt-3">
          <h5 class="section-title" i18n="@@filters">Filtros activos</h5>
          <div class="w-full h-auto max-h-[23vh] overflow-auto rounded-md bg-gray-100 border border-gray-200">
            <p-scrollPanel styleClass="custombar1">
              @for (filtre of filter.forDisplay; track filtre) {
                <div class="filter-tag flex items-center justify-between px-3 py-2">
                  <span class="text-base ">
                    @if (filtre.filter_elements.length === 0) {
                      * {{ selectedColumn.display_name.default }} is {{ filtre.filter_type }}
                    }
                    @if (filtre.filter_elements.length === 1) {
                      * {{ selectedColumn.display_name.default }} {{ filtre.filter_type }} "{{ filtre.filter_elements[0].value1 }}"
                    }
                    @if (filtre.filter_elements.length === 2) {
                      * {{ selectedColumn.display_name.default }} {{ filtre.filter_type }} "{{ filtre.filter_elements[0].value1 }}" Y "{{ filtre.filter_elements[1].value2 }}"
                    }
                  </span>
                  <div class="flex items-center gap-2 ml-2 shrink-0">
                    <span class="text-base text-gray-500 whitespace-nowrap">
                      {{ filtre.filterBeforeGrouping ? whereMessage : havingMessage }}
                    </span>
                    <i class="pi pi-times cursor-pointer text-gray-400 hover:text-red-500 text-xs" (click)="removeFilter(filtre)"></i>
                  </div>
                </div>
              }
            </p-scrollPanel>
          </div>
        </div>
      }

    </div>
  </div>
</eda-dialog2>
